import React from 'react';
import { connect } from 'react-redux';
import { ReduxStateType, CmsPageContentIdentifier } from '@/types/av-check';

export interface StateProps {
  faq: string
}

const Faq = ({ faq }: StateProps) => (
  <span dangerouslySetInnerHTML={{ __html: faq }} />
);

const mapStateToProps = (state: ReduxStateType) => ({
  faq: state.cmsContent ? state.cmsContent[CmsPageContentIdentifier.Faq] : '',
});

export default connect(mapStateToProps)(Faq);
